import { makePrefixAdder } from '../utils/type-utils';

const addPrefixTo = makePrefixAdder('WAITER_OF_PROCESS');
const IS_ACTIVE = addPrefixTo('IS_ACTIVE');
const IS_DISABLE = addPrefixTo('IS_DISABLE');
const SET_PAYLOAD = addPrefixTo('SET_PAYLOAD');
const SET_PROCESSING = addPrefixTo('SET_PROCESSING');
const SET_LIST = addPrefixTo('SET_LIST');
const RESET_LIST = addPrefixTo('RESET_LIST');
const SET_VIDEO_CONFIG = addPrefixTo('SET_VIDEO_CONFIG');
const RESET_VIDEO_CONFIG = addPrefixTo('RESET_VIDEO_CONFIG');

const initialState = {
    isVisible: false,
    waiterChildren: {},
    waiterChildrenIsProcessing: {},
    list: [],
    videoConfig: { width: null, height: null }
};

export const reducer = (state = initialState, action) => {
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    switch (action.type) {
        case IS_ACTIVE:
            return {
                ...state,
                isVisible: true
            };
        case IS_DISABLE:
            return {
                ...state,
                isVisible: false
            };
        case SET_PAYLOAD: {
            return {
                ...state,
                waiterChildren: { ...state.waiterChildren, [action.childrenId]: action.payload }
            };
        }
        case SET_PROCESSING: {
            return {
                ...state,
                waiterChildrenIsProcessing: {
                    ...state.waiterChildrenIsProcessing,
                    [action.childrenId]: action.processingStatus
                }
            };
        }
        case SET_LIST: {
            return {
                ...state,
                list: action.payload
            };
        }
        case RESET_LIST: {
            return {
                ...state,
                list: []
            };
        }
        case SET_VIDEO_CONFIG: {
            return {
                ...state,
                videoConfig: action.payload
            };
        }
        case RESET_VIDEO_CONFIG: {
            return {
                ...state,
                videoConfig: { width: null, height: null }
            };
        }
        default:
            return state;
    }
};

const activateWaiter = () => ({ type: IS_ACTIVE });

const deActivateWaiter = () => ({
    type: IS_DISABLE
});

const setPayload = ({ payload, childrenId }) => ({
    type: SET_PAYLOAD,
    payload,
    childrenId
});

const setProcessing = ({ childrenId, processingStatus }) => ({
    type: SET_PROCESSING,
    childrenId,
    processingStatus
});

const setList = payload => ({ type: SET_LIST, payload });

const resetList = () => ({ type: RESET_LIST });

const setVideoConfig = payload => ({ type: SET_VIDEO_CONFIG, payload });

const resetVideoConfig = () => ({ type: RESET_VIDEO_CONFIG });

export const actions = {
    activateWaiter,
    deActivateWaiter,
    setPayload,
    setProcessing,
    setList,
    resetList,
    setVideoConfig,
    resetVideoConfig
};

export const waiterVisibilitySelector = state => state.waiterOfProcess.isVisible;

export const waiterChildrenSelector = state => {
    const waiterState = state.waiterOfProcess;

    const { waiterChildren } = waiterState || {};

    const filteredWaiters = {};

    const allWaiters = Object.keys(waiterChildren);

    for (const id of allWaiters) {
        if (!!id && waiterChildren[id]) {
            filteredWaiters[id] = { ...waiterChildren[id] };
        }
    }

    return filteredWaiters;
};

export const waiterChildrenAreExistSelector = state => {
    const waiterState = state.waiterOfProcess;

    const { waiterChildren } = waiterState;

    return Boolean(Object.values(waiterChildren).filter(Boolean).length);
};

export const videoWaiterBusySelector = state => {
    const waiterState = state.waiterOfProcess;

    const { waiterChildren, waiterChildrenIsProcessing } = waiterState;
    const activeChildes = Object.keys(waiterChildren).filter(childrenKey => {
        const element = waiterChildren[childrenKey];
        const progressOfElement = waiterChildrenIsProcessing[childrenKey];

        return !!element && progressOfElement;
    });

    return Boolean(activeChildes.length);
};

export const existVideoWaiterSelector = state => {
    const waiterState = state.waiterOfProcess;

    const { waiterChildren } = waiterState;

    const waiterIds = [];

    for (const childrenKey of Object.keys(waiterChildren)) {
        const element = waiterChildren[childrenKey];

        if (!!element) {
            waiterIds.push(childrenKey);
        }
    }

    return waiterIds;
};

export const waiterVideoParamsSelector = state => state.waiterOfProcess.videoConfig;

export const waiterEpisodeList = state => state.waiterOfProcess.list;
